var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import MatchResultOutcome from '../outcomes/MatchResultOutcome';
import { byIdComparator, slotName } from './slotUtils';
var MatchResultSlot = function (props) {
    var outcomes = props.outcomes, gridLocalization = props.gridLocalization, section = props.section, slot = props.slot, match = props.match, expanded = props.expanded;
    var renderOutcomes = [];
    var outcomeProps = {
        gridLocalization: gridLocalization,
        section: section,
        slotName: slotName(slot, outcomes.toArray()[0], gridLocalization, match),
        slotFamily: slot.family,
        expanded: expanded
    };
    var i = 0;
    outcomes.sort(byIdComparator).map(function (outcome) {
        var isFirst = i === 0;
        renderOutcomes.push(_jsx(MatchResultOutcome, __assign({ outcome: outcome }, outcomeProps, { isFirst: isFirst }), outcome.get('id')));
    });
    return renderOutcomes;
};
MatchResultSlot.propTypes = {
    outcomes: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    slot: PropTypes.object.isRequired,
    slotName: PropTypes.string,
    match: PropTypes.object.isRequired,
    filteredRates: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired
};
export default MatchResultSlot;



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/MatchResultSlot.jsx